import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNotifyFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M10 2C10.5312 2 11 2.46875 11 3V3.625C13.2812 4.0625 15 6.09375 15 8.5V9.09375C15 10.5625 15.5313 12 16.5 13.0937L16.7188 13.3437C17 13.6562 17.0625 14.0625 16.9062 14.4375C16.75 14.7812 16.375 15 16 15L4 15C3.59375 15 3.21875 14.7812 3.0625 14.4375C2.90625 14.0625 2.96875 13.6562 3.25 13.3438L3.46875 13.0938C4.4375 12 5 10.5625 5 9.09375L5 8.5C5 6.09375 6.71875 4.0625 9 3.625V3C9 2.46875 9.4375 2 10 2ZM11.4063 17.4375C11.0313 17.8125 10.5313 18 10 18C9.46875 18 8.9375 17.8125 8.5625 17.4375C8.1875 17.0625 8 16.5312 8 16H10H12C12 16.5312 11.7813 17.0625 11.4063 17.4375Z"
	})
});
const ForwardRef = forwardRef(SvgNotifyFilled);
export default ForwardRef;
